import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useResizeDetector } from "react-resize-detector/build/withPolyfill";
import { MouseSelectionContainer } from "~/components/MouseSelectionContainer";
import { TableView } from "~/components/TableView/index";
import { useTableViewItemsPositions } from "~/components/TableView/useTableViewItemsPositions";
import { useTableView } from "./TableViewContext";
export const SelectableTableView = (param)=>{
    let { scrollElementRef, horizontalPadding, ...rest } = param;
    const { width = 0, ref: widthRef } = useResizeDetector();
    const { getTableWidthAsNumber } = useTableView();
    const minTableWidth = useMemo(()=>getTableWidthAsNumber(), [
        getTableWidthAsNumber
    ]);
    const { rowPositions } = useTableViewItemsPositions({
        tableWidth: width,
        rows: rest.rows,
        horizontalPadding
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "relative",
        ref: widthRef,
        children: /*#__PURE__*/ _jsx(MouseSelectionContainer, {
            containerRef: widthRef,
            itemsPositions: rowPositions,
            scrollElementRef: scrollElementRef,
            children: /*#__PURE__*/ _jsx(TableView, {
                scrollElementRef: scrollElementRef,
                ...rest,
                minTableWidth: minTableWidth
            })
        })
    });
};
